import Resource from '@/services/resources/common';

// question type
export default class CategoryResource extends Resource {
  constructor(entrypoint = '/categories', alias = 'Category') {
    super(entrypoint, alias);
  }
}
